import lodash from 'lodash';

import {toQuery, toMutation, nodeWithArgs, node} from 'common/util/queryHelper';
import {queryGraphQL, mutateGraphQL} from 'common/util/query';
import {addApplicationMessage} from 'common/actions/applicationMessagesActions';

export const EVENT_TYPES_LOAD = 'EVENT_TYPES_LOAD';
export const CUSTOM_EVENT_TYPE_LOAD = 'CUSTOM_EVENT_TYPE_LOAD';
export const CUSTOM_EVENT_TYPE_UNLOAD = 'CUSTOM_EVENT_TYPE_UNLOAD';
export const EVENT_TYPES_UNLOAD = 'EVENT_TYPES_UNLOAD';
export const EVENT_TYPES_TOGGLE = 'EVENT_TYPES_TOGGLE';
export const EVENT_TYPES_CREATE = 'EVENT_TYPES_CREATE';
export const GET_DATA_SOURCES = 'GET_DATA_SOURCES';
export const REMOVE_DATA_SOURCES = 'REMOVE_DATA_SOURCES';


export function getInstitutionEventTypes(institutionId) {
    return async (dispatch) => {
        const institutionEventTypesQuery = toQuery(nodeWithArgs('allEventTypes', {
            institutionId,
        }, [
            'id',
            'displayName',
            'name',
            'description',
            'isEnabled',
        ]));
        const {
            errors,
            data: {
                allEventTypes: institutionEventTypes
            }
        } = await queryGraphQL(institutionEventTypesQuery);
        if (errors) {
            dispatch(addApplicationMessage('error', lodash.map(errors, 'message')));
            return;
        }
        dispatch(getInstitutionEventTypesAction(institutionEventTypes));
    };
}

export function getInstitutionDataSources(institutionId) {
    return async dispatch => {
        const dataSourcesQuery = nodeWithArgs('getDataSourcesForInstitution',
            {institutionId},
            [
                'id',
                'name',
                'parameters'
            ]
        );

        const results = await queryGraphQL(toQuery(dataSourcesQuery));

        if (results.errors) {
            dispatch(addApplicationMessage('error', 'An error occurred when loading the data sources'));
        } else {
            dispatch({
                type: GET_DATA_SOURCES,
                payload: results.data.getDataSourcesForInstitution
            });
        }
    };
}

export function removeInstitutionDataSources() {
    return {
        type: REMOVE_DATA_SOURCES,
    };
}

export function clearInstitutionEventTypes() {
    return {
        type: EVENT_TYPES_UNLOAD,
    };
}

export function createEventType(institutionId, eventType) {
    const createEventTypeMutation = nodeWithArgs('createEventType', {
        institutionId,
        input: {
            institutionId,
            name: eventType.title,
            displayName: eventType.displayName,
            description: eventType.description,
            primaryDateField: eventType.primaryDateField,
            slatOrder: eventType.slatOrder,
            fields: eventType.details.map(detail => {
                let values = detail.options;

                if (detail.dataSource) {
                    // TODO: Do this processing in chili instead
                    const dataSourceParameters = JSON.parse(detail.dataSource.parameters);
                    values = dataSourceParameters.values.map(parameterValue => parameterValue.text);
                }

                return {
                    name: detail.title,
                    displayName: detail.displayName,
                    label: detail.label,
                    view: detail.view,
                    description: detail.description,
                    placeholder: detail.placeholder,
                    dynamicSource: detail.dataSource ? detail.dataSource.label : null,
                    enableOtherOption: detail.enableOtherOption,
                    options: {
                        type: detail.sourceType,
                        values: values,
                    }
                };
            }),
            integrationPartnerIds: eventType.integrationPartnerIds,
        }
    }, [
        'id',
        'displayName',
        'name',
        'description',
        'isEnabled'
    ]);

    return async (dispatch) => {
        const results = await mutateGraphQL(toMutation(createEventTypeMutation));
        const {errors, data} = results;

        if (errors) {
            dispatch(addApplicationMessage('error', lodash.map(errors, 'message')));
            return;
        }
        const successMessage = 'Event type created!';
        dispatch(addApplicationMessage('success', successMessage));
        dispatch(createEventTypeAction(data.createEventType));
    };
}

export function toggleInstitutionEventType(institutionId, id, isEnabled) {
    const toggleInstitutionEventTypeQuery = nodeWithArgs('updateInstitutionEventType', {
        institutionId,
        id,
        isEnabled,
    }, [
        'id',
        'displayName',
        'name',
        'description',
        'isEnabled',
    ]);
    return async (dispatch) => {
        const results = await mutateGraphQL(toMutation(toggleInstitutionEventTypeQuery));
        const {
            errors,
            data: {
                updateInstitutionEventType
            }
        } = results;
        const {isEnabled} = updateInstitutionEventType;
        if (errors) {
            dispatch(addApplicationMessage('error', lodash.map(errors, 'message')));
            return;
        }
        const successMessage = isEnabled ? 'Event Type was enabled' : 'Event Type was disabled';
        dispatch(addApplicationMessage('success', successMessage));
        dispatch(toggleInstitutionEventTypeAction(updateInstitutionEventType));
    };
}

export function createEventTypeAction(eventType) {
    return {
        type: EVENT_TYPES_CREATE,
        payload: eventType,
    };
}


export function getInstitutionEventTypesAction(eventTypes) {
    return {
        type: EVENT_TYPES_LOAD,
        payload: eventTypes
    };
}


export function toggleInstitutionEventTypeAction(institutionEventType) {
    return {
        type: EVENT_TYPES_TOGGLE,
        payload: institutionEventType
    };
}

export function getCustomEventType(institutionId, eventTypeId) {
    const eventTypeQuery = nodeWithArgs('customEventType', {
        eventTypeId,
        institutionId,
    }, [
        'id',
        'name',
        'displayName',
        'description',
        'slatFields',
        'primaryDateField',
        'integrationPartnerIds',
        node('fields', [
            'id',
            'name',
            'view',
            'displayName',
            'valueType',
            'enableOtherOption',
            'description',
            node('options', [
                'type',
                'source',
                'values',
            ]),
        ]),
    ]);

    return async (dispatch) => {
        const results = await queryGraphQL(toQuery(eventTypeQuery));
        const { errors, data } = results;
        if (errors) {
            dispatch(addApplicationMessage('error', lodash.map(errors, 'message')));
            return;
        }
        dispatch({ type: CUSTOM_EVENT_TYPE_LOAD, payload: data.customEventType });
    };
}

export function unloadCustomEventType() {
    return {
        type: CUSTOM_EVENT_TYPE_UNLOAD,
        payload: {}
    };
}
